'use client';

import { Button } from '@unreserved/ui/components/button';
import { useToast } from '@unreserved/hooks';
import { GoogleIcon } from '@/app/_components/icons/google';
import { useAuth } from '@/hooks/use-admin-auth';
import { SocialAuthDtoProviderEnum } from '@unreserved/sdk';

const LOGIN_ERROR_FALLBACK =
  'Invalid credentials or unregistered user. Please try again.';

export function GoogleLoginButton() {
  const { toast } = useToast();
  const {
    getSocialAuthUrl,
    socialAuthUrlResult,
    isSocialAuthRedirecting,
  } = useAuth();

  const isLoading =
    socialAuthUrlResult.isPending || isSocialAuthRedirecting;

  const handleGoogleLogin = async () => {
    if (isLoading) return;
    try {
      await getSocialAuthUrl({
        provider: SocialAuthDtoProviderEnum.Google,
      });
    } catch (error) {
      const err = error as Error & { response?: Response };
      let description: string = err?.message?.trim() || LOGIN_ERROR_FALLBACK;
      if (err?.response) {
        try {
          const data = (await err.response.json()) as { message?: string };
          if (data?.message?.trim()) description = data.message.trim();
        } catch {
          // use description from err.message or fallback
        }
      }
      toast.error('Login failed', { description });
    }
  };

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleGoogleLogin}
      disabled={isLoading}
      className="cursor-pointer flex h-[50px] w-full items-center justify-center gap-3 rounded-[8px] border-border-300 !bg-background-0 px-6 text-[16px] font-normal text-typography-900 hover:!bg-background-0 hover:!text-typography-900"
    >
      <GoogleIcon className="h-6 w-6" />
      <span>
        {isLoading ? 'Loading...' : 'Continue with Google'}
      </span>
    </Button>
  );
}
